import { render, staticRenderFns } from "./ArticleTypeIcon.vue?vue&type=template&id=73445f06&scoped=true&"
import script from "./ArticleTypeIcon.vue?vue&type=script&lang=js&"
export * from "./ArticleTypeIcon.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTypeIcon.vue?vue&type=style&index=0&id=73445f06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73445f06",
  null
  
)

export default component.exports